export enum TaxFreeAmount {
  Full = 0,
  Half = 1,
  OneThird = 2,
  None = 3,
}
